export const ok = res => ({ result: true, msg: res?.error_msg ?? 'OK', data: res?.data });
export const error = res => {
  let msg = '接口请求错误，无返回值。';
  msg = res?.error_msg ?? '接口请求错误，无错误信息。';
  msg = res?.message ?? msg;
  return { result: false, msg };
};